class LocaleLibrary{
    constructor(json){
        this.en = json.en;
        this.bm = json.bm;
    }
}

export default LocaleLibrary